import { Toaster as HotToaster } from 'react-hot-toast';
import { tokens } from '@/styles/tokens';

// react-hot-toast paints its own white background inline, so the theme colours go through
// `style` (CSS variables from globals.css, which follow the dark/light theme) not classNames.
const toastStyle = {
  background: 'rgb(var(--shell-panel))',
  color: 'rgb(var(--shell-fg))',
  border: '1px solid rgb(var(--shell-border))',
  borderRadius: '12px',
  boxShadow: '0 12px 32px rgb(0 0 0 / 0.25)',
  padding: '10px 14px',
  fontSize: '14px',
  maxWidth: '380px',
};

export function Toaster() {
  return (
    <HotToaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerStyle={{ top: 16, right: 16 }}
      toastOptions={{
        duration: 4000,
        style: toastStyle,

        success: {
          duration: 4000,
          style: { ...toastStyle, borderLeft: `4px solid ${tokens.successEmerald}` },
          // iconTheme requires literal color strings — pulled from the central
          // JS token mirror in `@/styles/tokens` (sourced from tailwind.config.js).
          iconTheme: {
            primary: tokens.successEmerald,
            secondary: tokens.bodyInverse,
          },
        },
        error: {
          duration: 5000,
          style: { ...toastStyle, borderLeft: `4px solid ${tokens.dangerRed}` },
          iconTheme: {
            primary: tokens.dangerRed,
            secondary: tokens.bodyInverse,
          },
        },
      }}
    />
  );
}
